module.exports = __webpack_public_path__ + "img/logo-error.e357320c.svg";